import { Link } from "@tanstack/react-router";
import { MapPin } from "lucide-react";

type CitySlug = "calgary-ab" | "airdrie-ab" | "cochrane-ab" | "chestermere-ab" | "okotoks-ab";

// Varied, city-specific anchor phrases by context.
// Service context leans toward installs/garages; blog context leans toward neighborhoods/homes.
const ANCHORS: Record<CitySlug, { service: string; blog: string }> = {
  "calgary-ab": {
    service: "Calgary garages & commercial floors",
    blog: "Calgary epoxy installs",
  },
  "airdrie-ab": {
    service: "Airdrie shops & home garages",
    blog: "Airdrie garage floors",
  },
  "cochrane-ab": {
    service: "Cochrane acreage workshops",
    blog: "Cochrane garage floor coatings",
  },
  "chestermere-ab": {
    service: "Chestermere lakeside homes",
    blog: "Chestermere garage installs",
  },
  "okotoks-ab": {
    service: "Okotoks family garages",
    blog: "Okotoks workshop floors",
  },
};

const ORDER: CitySlug[] = ["calgary-ab", "airdrie-ab", "cochrane-ab", "chestermere-ab", "okotoks-ab"];

type Props = {
  context: "service" | "blog";
  /** Lead-in phrase before the city links. */
  lead?: string;
};

export function CityLinksStrip({ context, lead }: Props) {
  const intro =
    lead ??
    (context === "service"
      ? "Installed across the Calgary Region —"
      : "Serving homeowners and businesses across the Calgary Region —");

  return (
    <section className="border-t border-border bg-jet">
      <div className="container-x py-10">
        <div className="flex items-start gap-3">
          <MapPin className="mt-1 h-4 w-4 shrink-0 text-copper" aria-hidden />
          <p className="text-sm leading-relaxed text-silver">
            <span className="font-semibold text-silver-light">{intro}</span>{" "}
            {ORDER.map((slug, i) => {
              const anchor = ANCHORS[slug][context];
              const isLast = i === ORDER.length - 1;
              return (
                <span key={slug}>
                  <Link
                    to={`/service-areas/${slug}` as string}
                    className="text-copper underline-offset-4 hover:underline"
                  >
                    {anchor}
                  </Link>
                  {isLast ? "." : i === ORDER.length - 2 ? ", and " : ", "}
                </span>
              );
            })}
          </p>
        </div>
      </div>
    </section>
  );
}
